import React, { useState, useEffect } from "react";
import { observer } from "mobx-react-lite";
import useStores from "stores";
import { useHistory } from "react-router-dom";
import RichText from 'components/RichText';

import "./index.scss";

const ButtJoint = observer(({detail, support}) => {
  const [data, setData] = useState(null);
  const [isload, setIsload] = useState(true);
  let html = `
    <style>
      body,p {
        margin: 0;
      }
    </style>
    ${detail.bigContent || ''}
  `;

  const toLink = (item) => {
    log("VopOpenIndex_1602911919488", '40');
    console.log('item', item)
    window.location.href = item.url;
    // let id = item?.url.split('id')[1]
    // history.push(
    //   `/doc/api?id=${id}`
    // );
  };

  return (
    <div className="componets_details_buttJoint">
      <div className="main_content">
        <RichText html={html} />
      </div>
      { support && detail?.bigContent.length > 0 && <div className="content_footer">
        <div className="component-box component-support">
          <h4 className="c_title">文档与支持</h4>
          <ul className="support-list">
            { support && support.map((item, index)=> {
              return (
              <li className="support-item" key={index}>
                <div 
                  onClick={()=> {toLink(item)}}
                >
                  {item.title}
                </div>
              </li> )
            })}
          </ul>
        </div>
      </div>}
    </div>
  );
});

export default ButtJoint;
